import server from './server'

export const getQualifyingQuestions = (params = {}) => {
  return server.get('/qualifying_questions', {
    params: { zone_code: params['zoneCode'], destination_code: params['destinationCode'], include: "children" }
  })
}
